<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
          ></div>
          <div class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('corporatepartner.search')"
              class="kh-font"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.partner_name_kh }}</td>
          <td>{{ record.partner_name_en }}</td>
          <td>{{ record.contact_no }}</td>
          <td>{{ record.discount_rate }}</td>
          <td>{{ record.partner_address }}</td>

          <td class="text-center">
            <a
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  props: ['fetch'],
  name: 'corporate-partner-table',
  data() {
    return {
      loading: false,
      columns: [
        { name: this.$t('corporatepartner.nameKh'), style: 'width:17%' },
        { name: this.$t('corporatepartner.nameEn'), style: 'width:17%' },
        { name: this.$t('corporatepartner.contactNo') },
        { name: this.$t('corporatepartner.discountRate') },
        { name: this.$t('corporatepartner.address') },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('corporatePartner', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.corporatePartner.search
      },
      set(newValue) {
        this.$store.commit('corporatePartner/SET_SEARCH', newValue)
        this.$store.commit('corporatePartner/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('corporatePartner/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('corporatePartner/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'corporate-partner-edit',
        params: { id: record.cpp_id }
      })
    },

    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('corporatePartner/destroy', record.cpp_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),

    fetch: function() {
      this.fetchData()
      this.$emit('fetched')
    }
  }
}
</script>
